import { useCallback, useState, useEffect } from "react";
import { useRealtimeTranscriptionContext } from "../contexts/RealtimeTranscriptionContext";
import { TranscriptionHandler } from "../interfaces/Transcription";

export function useRealtimeTranscription(
  onTranscription: TranscriptionHandler,
  options: { language?: string; enableVad?: boolean } = {}
) {
  const {
    isConnected,
    isRecording,
    transcript,
    completeTranscript,
    error,
    startRecording,
    stopRecording,
    // enableStreaming,
    // disableStreaming,
    resetTranscription,
  } = useRealtimeTranscriptionContext();

  const [localTranscript, setLocalTranscript] = useState("");
  const [localCompleteTranscript, setLocalCompleteTranscript] = useState("");

  useEffect(() => {
    setLocalTranscript(transcript);
  }, [transcript]);

  useEffect(() => {
    setLocalCompleteTranscript(completeTranscript);
  }, [completeTranscript]);

  const startListening = useCallback(async () => {
    await startRecording();
  }, [startRecording]);

  const stopListening = useCallback(async () => {
    await stopRecording();
  }, [stopRecording]);

  return {
    isRecording,
    isTranscribing: isConnected && !isRecording,
    isRtcConnected: isConnected,
    transcript: localTranscript,
    completeTranscript: localCompleteTranscript,
    error,
    startListening,
    stopListening,
    // enableStreaming,
    // disableStreaming,
    resetError: () => {}, // Not needed in context
    resetTranscription,
  };
}
